import capitalize from 'lodash-es/capitalize'
import {format, differenceInHours} from 'date-fns/esm'

export function renderContratInterim (contrat) {
  var interimaire = contrat.interimaireByInterimaireId
  var iade = contrat.iadeByIadeId
  var fullName = interimaire.salutation + ' ' + capitalize(interimaire.prenom) + ' ' + interimaire.nom.toUpperCase()
  var duree = differenceInHours(new Date(contrat.dateFin), new Date(contrat.dateDebut))
  console.log(duree)
  var content = []
  content.push({
    text: `CONTRAT DE TRAVAIL A DUREE DETERMINEE 
  à terme précis conclu pour un remplacement temporaire`,
    font: 'Lato',
    fontSize: 12,
    bold: true
  })
  content.push(`
Entre les soussignées: 

- La SCM CABINET D’ANESTHESIE DES CEDRES, dénommée ci-après « la Société », au capital de 1 000 euros, dont le siège social est situé à Echirolles (38130) – 48 Avenue Grugliasco, immatriculée au Registre du Commerce et des Sociétés de Grenoble sous le numéro D 488 874 470, représentée par Monsieur Steve MAZE ou Monsieur Olivier BRETON, agissant en qualité de cogérants ayant tous pouvoirs à l’effet des présentes, 
Cotisant à l’Urssaf de Grenoble sous le numéro 388000001400961664

d’une part, et:

- ${fullName}
Demeurant à ${interimaire.adresse}, 
Né(e) le ${format(new Date(interimaire.dateNaiss), 'dd/MM/yyyy')} à ${interimaire.lieuNaiss} (département: ${interimaire.departementNaiss}) 
Pays de nationalité: ${interimaire.nationalite}, 
Immatriculée à la Sécurité Sociale sous le numéro ${interimaire.numss}. 
`)
  if (interimaire.nationalite !== 'France') {
    content.push(`Si non ressortissant européen : 
Titulaire d’une carte de séjour et de travail n°                    , expirant le                                            , 
Délivrée le                        par la Préfecture du département du                                  
(original de la carte présenté au signataire du présent contrat le …………..)`)
  }

  content.push(`Disposant de la pleine capacité pour s’engager à l’égard des présentes

  d’autre part,
Il a été convenu et arrêté ce qui suit: 

Conformément aux dispositions légales, une déclaration préalable à l’embauche a été effectuée auprès de l’URSSAF de Grenoble.
En vertu de la loi n° 78-17 du 6 février 1978, ${fullName} dispose d’un droit d’accès et de rectification des données relatives à la déclaration qui sont enregistrées dans le fichier informatisé de l’URSSAF.

`)
  content.push({text: 'Article 1er  Engagement', bold: true})

  content.push(`
  ${fullName} s’engage à travailler pour le compte du Cabinet à compter du ${format(new Date(contrat.dateDebut), 'dd/MM/yyyy')} en qualité d’infirmier anesthésiste, coefficient 235, pour une durée déterminée, conformément aux dispositions de l’article L 1242-2, 1° a) du Code du travail. 
${fullName} déclare formellement n’être lié à aucune autre entreprise et avoir quitté son précédent employeur libre de tout engagement. 
Au plus tard le jour de son embauche, ${fullName} fournira au signataire du présent contrat, tous les éléments nécessaires pour constituer son dossier, notamment: 

références professionnelles, 
copie de diplômes, 
attestation d’employeur justifiant d’une activité salariée autre exercée en parallèle avec indication de la durée du travail et de sa répartition, 
justificatif du bénéfice d’une couverture complémentaire santé et prévoyance.

 `)
  content.push({text: 'Article 2  Durée et objet du contrat', bold: true})

  content.push(`
Le contrat prend effet le ${format(new Date(contrat.dateDebut), 'dd/MM/yyyy')} à ${format(new Date(contrat.dateDebut), 'H:mm')} heures pour une durée précise.
Ce contrat prendra fin le ${format(new Date(contrat.dateFin), 'dd/MM/yyyy')} à ${format(new Date(contrat.dateFin), 'H:mm')} heures automatiquement et sans formalité.

Le présent contrat est conclu en vue d’assurer le remplacement de ${iade.nom.toUpperCase() + ' ' + capitalize(iade.prenom)}, employé(e) en qualité d'Infirmier Anesthésiste et actuellement absent(e) pour cause de ${contrat.raison}.

Le présent contrat ne pourra être rompu avant son terme qu’en cas de faute grave, de force majeure, d’un commun accord ou d’inaptitude physique constatée par le médecin du travail.

 `)
  content.push({text: 'Article 3  Période d’essai', bold: true})
  content.push(`Compte tenu de sa durée réduite, le présent contrat est conclu sans période d’essai.

`)
  content.push({text: 'Article 4  Fonctions', bold: true})

  content.push(`${fullName} sera employé en qualité d’infirmier anesthésiste, coefficient 235.

Dans le cadre de ses fonctions, ${fullName} sera notamment chargé d’exécuter les missions suivantes :
  Accueil du malade en salle d’opération et préparation du matériel d’anesthésie,
  Assistance du médecin anesthésiste pendant la durée de l’anesthésie,
  Assistance au réveil de l’opéré, surveillance pendant quelques heures dans la salle de réveil. 

${fullName} devra rendre compte, dans les meilleurs délais, auprès de son responsable hiérarchique de toutes les difficultés qu’il pourrait rencontrer dans le cadre de ses fonctions afin de permettre à la Société de prendre toutes dispositions. 
Chaque salarié, quel que soit son niveau de classification, exécute les missions et tâches qui lui sont confiées avec la conscience professionnelle requise. Il est responsable des missions et tâches qui lui sont dévolues et de la bonne utilisation du matériel qui lui est confié. 
${fullName} exercera ses fonctions dans le cadre des directives qui lui seront données par sa hiérarchie.

`)
  content.push({text: 'Article 5 Durée du travail', bold: true})

  content.push(`La répartition des horaires de travail sera déterminée par le tableau de service auquel vous devrez vous conformer.
L'organisation hebdomadaire et journalière du travail pourra être modifiée en fonction des impératifs du service et vous en acceptez dores et déjà les contraintes.
${fullName} s’engage à observer la plus grande assiduité au travail et à se conformer aux horaires résultant des modes d’organisation actuels et à venir en vigueur au sein de l’entreprise, le mode d’organisation du temps de travail et la répartition des horaires de travail n’étant pas considérés comme des éléments essentiels des présentes. 

`)
  content.push({text: 'Article 6 Rémunération', bold: true})

  content.push(`${fullName} percevra une rémunération brute établie sur la base d’un taux horaire brut de ${contrat.tauxBrut || '29.00'} €.
${fullName} percevra à la fin de son contrat, en même temps que son salaire, une indemnité de précarité d’emploi, aux conditions et taux fixés par le Code du travail.

`)
  content.push({text: 'Article 7 Lieu et modalités de travail', bold: true})

  content.push(`A titre informatif, ${fullName} exercera ses fonctions au siège du Cabinet sis 48, avenue Grugliasco à Echirolles (38130).

`)
  content.push({text: 'Article 8  Maladie', bold: true})

  content.push(`En cas d’empêchement pour lui d’effectuer son travail, ${fullName} est tenu d’en aviser immédiatement le Cabinet en précisant la durée prévisible de cet empêchement. 
Si cette absence est justifiée par la maladie ou l’accident, ${fullName} devra, en outre, faire parvenir un certificat médical indiquant la durée probable du repos dans les trois jours. 
La même formalité est requise en cas de prolongation de l’arrêt de travail. 

`)
  content.push({text: 'Article 9  Discrétion - Confidentialité', bold: true})

  content.push(`${fullName} s’engage à conserver de la façon la plus stricte, la discrétion la plus absolue tant à l’intérieur qu’à l’extérieur du Cabinet, sur l’ensemble des renseignements (notamment sur la situation financière du Cabinet, sa gestion, son fonctionnement, ses projets, les données relatives à la clientèle) qu’il pourra recueillir à l’occasion de ses fonctions ou du fait de sa présence dans l’entreprise. 
Cette obligation de discrétion et de confidentialité demeurera même après la fin du présent contrat, quelle que soit la cause de son terme. 

`)
  content.push({text: 'Article 10  Matériels & documents', bold: true})

  content.push(`${fullName} s’interdit de prendre, en vue de son usage personnel ou pour tout autre usage, non autorisé expressément, des copies ou des reproductions de tout document appartenant au Cabinet ou à ses clients. 

`)
  content.push({text: 'Article 11 Obligations du salarié', bold: true})

  content.push(`Pendant la durée de son contrat, ${fullName} s’engage à respecter les instructions qui pourront lui être données par le Cabinet et à se conformer aux règles relatives à l’organisation et au fonctionnement internes du Cabinet.
${fullName} devra informer la Société, sans délai, de tous changements qui interviendraient dans les situations qu’il a signalées lors de son engagement (adresse, situation de famille etc.).
${fullName} s’engage à respecter scrupuleusement les normes et directives de qualité des tâches qui lui seront imparties. 
Il devra prêter la plus grande attention à la clientèle fréquentant le Cabinet et le plus grand soin dans la réalisation de ses fonctions.

`)
  content.push({text: 'Article 12  Congés payés', bold: true})

  content.push(`${fullName} bénéficiera, s’il n’a pu effectivement prendre de congés payés, d’une indemnité compensatrice de congé payés calculée selon les dispositions légales. 

`)
  content.push({text: 'Article 13  Dispositions diverses' , bold: true})

  content.push(`${fullName} bénéficiera du régime de retraite, de prévoyance complémentaire en vigueur au sein du Cabinet. Les cotisations correspondantes seront prélevées sur sa rémunération.

Les organismes compétents sont les suivants:

Prémalliance 47 avenue Marie Reynoard 38067 Grenoble Cedex 2, 
		(affiliation M0890461540000)

IRSEA CAPICAF : 47 avenue Marie Reynoard 38067 Grenoble cedex 02
		(affiliation GRN0910700017501)

pour lesquels ${fullName} ne pourra refuser d’acquitter sa quote-part de cotisations, ni refuser le bénéfice des prestations servies telles qu’elles sont actuellement prévues ou telles qu’elles sont susceptibles de devenir, par suite de modifications des régimes et des taux de cotisations actuellement en vigueur.
Sous réserve des cas de dispense de droit ou de ceux prévus dans l’acte fondateur du régime, ${fullName} bénéficiera du régime collectif et obligatoire de mutuelle santé en vigueur au sein de l’entreprise. 
Il sera à ce titre affilié à l’organisme suivant : April Entreprise TSA 70112 69501 LYON CEDEX 03.
S’il souhaite être dispensé d’adhésion au régime, à condition de se trouver dans une situation le permettant, ${fullName} s’engage à remettre à la Société une demande de dispense dument signée et accompagnée des justificatifs requis. A défaut, il ne pourra s’opposer au paiement de sa quote part de cotisation. 

Les conditions d’application du contrat de travail seront notamment régies par les dispositions étendues de la Convention collective nationale du personnel des cabinets médicaux du 14 octobre 1981 étendue par arrêté du 15 janvier 1982 paru au JO du 12 février 1982, brochure JO n° 3168), consultable sur le site internet www.legifrance.gouv.fr et au service du personnel

${fullName} reconnaît avoir reçu un exemplaire du présent contrat.

Fait à Echirolles 
En deux exemplaires originaux,

Le 

Pour la Société,								Le salarié, 
Le gérant								        ${fullName}
`
  )
  return content
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/ContratInterim.js